/**
 * @file parser.ts
 * @description GCOME_AP 常用只读响应解析器。
 */

import type { GcomeApBaseInfo, GcomeApFuncInfo, GcomeApInfo } from './types'

export function parseGcomeApInfo(data: Uint8Array): GcomeApInfo {
  requireLength(data, 7, 'GetInfo')
  const status = data[6] ?? 0
  return {
    version: readU16LE(data, 0),
    rfVersion: readU16LE(data, 2),
    moduleVersion: readU16LE(data, 4),
    has16kDriver: Boolean(status & 0x01),
    isUsb3: Boolean(status & 0x02),
  }
}

export function parseGcomeApBaseInfo(data: Uint8Array): GcomeApBaseInfo {
  requireLength(data, 6, 'GetBase')
  return {
    currentProfile: data[0],
    maxProfiles: data[1],
    profileOrder: Array.from(data.slice(2, 6)),
  }
}

export function parseGcomeApFuncInfo(data: Uint8Array): GcomeApFuncInfo {
  requireLength(data, 40, 'GetFunc')
  const reportAndTick = data[4]
  const battery = data[32]

  return {
    reportRateCode: reportAndTick & 0x0f,
    tickRateCode: (reportAndTick >> 4) & 0x0f,
    lockMask: data[6],
    performanceMask: data[7],
    lightMode: data[8],
    brightness: data[9],
    speed: data[10],
    direction: data[11],
    colorful: Boolean(data[12]),
    colorIndex: data[13],
    color: { r: data[14], g: data[15], b: data[16] },
    sideLightMode: data[24],
    sideBrightness: data[25],
    sideSpeed: data[26],
    sideColorful: Boolean(data[27]),
    sideColorIndex: data[28],
    sideColor: { r: data[29], g: data[30], b: data[31] },
    batteryPercent: battery & 0x7f,
    charging: Boolean(battery & 0x80),
    sleepTimeCode: data[35],
    neverSleep: data[35] === 0,
    connectionMode: data[36],
    rfChannel: data[37],
    btChannel: data[38],
    fullKeyRollover: Boolean(data[33]),
  }
}

function requireLength(data: Uint8Array, length: number, label: string): void {
  if (data.length < length) {
    throw new Error(`${label} 响应至少需要 ${length} 字节，当前为 ${data.length} 字节。`)
  }
}

function readU16LE(data: Uint8Array, offset: number): number {
  return data[offset] | (data[offset + 1] << 8)
}
